import { FormProvider, useForm } from 'react-hook-form';
import { DynamicFieldData } from './dynamic-control-types';
import { DynamicControl } from './DynamicControl';
import classNames from 'classnames';
import { useContext, useEffect } from 'react';
import { ChatbotContext } from 'providers/ChatbotProvider';
import { Button } from 'primereact/button';
import MarkdownComponent from 'components/MarkdownComponent';

interface FormProps {
    fields: DynamicFieldData[];
    onSubmit: (data, error) => void;
    disabled?: boolean;
    intent?: string;
}

export const Form = ({ fields, onSubmit, disabled, intent }: FormProps) => {
    const formMethods = useForm();
    const { botDetail, botReplyLoading } = useContext(ChatbotContext);

    const { setFocus, handleSubmit, formState } = formMethods;
    const { isSubmitting } = formState;

    const candidateIntent = botDetail.apis.find((api) => api.intentDetail.name === intent);
    const intentHeader = candidateIntent?.intentDetail.intentHeader || '';

    useEffect(() => {
        if (!fields) return;

        setFocus(fields[0].fieldName);
    }, []);

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="chat-form">
                <FormProvider {...formMethods}>
                    {intentHeader && (
                        <div
                            className="slot-form-header"
                            style={{
                                fontFamily: `${botDetail.botSettings?.font}`,
                                color: `${botDetail.botSettings?.botMessageTextColor}`
                            }}>
                            {intentHeader}
                        </div>
                    )}

                    {fields.map((dataField: DynamicFieldData, index) => {
                        if (!dataField.fieldName) dataField.fieldName = 'Unknown';

                        return (
                            <div
                                key={index}
                                className={classNames('form-row', {
                                    'form-disabled': botReplyLoading
                                })}>
                                {index !== 0 && <div className="chat-form-field-separator" />}

                                <div className="form-column twelve">
                                    {dataField.heading && (
                                        <div className="slot-form-header">
                                            <MarkdownComponent>{dataField.heading}</MarkdownComponent>
                                        </div>
                                    )}

                                    {dataField.label && (
                                        <label className="slot-form-label" htmlFor={dataField.fieldName}>
                                            <MarkdownComponent>{dataField.label}</MarkdownComponent>
                                        </label>
                                    )}

                                    <div className="chat-form-field">
                                        <DynamicControl
                                            {...dataField}
                                            botDetail={botDetail}
                                            disabled={disabled}
                                            intent={candidateIntent}
                                        />
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                    <Button outlined type="submit" disabled={isSubmitting || botReplyLoading || disabled}>
                        {isSubmitting ? 'Submitting' : 'Submit'}
                    </Button>
                </FormProvider>
            </div>
        </form>
    );
};
